// Function to disable scrolling
function disableScroll() {
  document.body.classList.add("modal-open");
}

// Function to enable scrolling
function enableScroll() {
  document.body.classList.remove("modal-open");
}

// Function to show the modal with fade-in effect
function showModal() {
  const modal = document.querySelector("#subscribeBar");
  if (modal) {
    modal.style.display = "flex";
    setTimeout(() => {
      modal.classList.add("show");
      disableScroll();
    }, 10);
  }
}

// Function to hide the modal
function hideModal() {
  const modal = document.querySelector("#subscribeBar");
  if (modal) {
    modal.classList.remove("show");
    enableScroll();
    setTimeout(() => {
      modal.style.display = "none";
    }, 300);
  }
}

// Check for cookie on page load
if (document.cookie.indexOf("subscribeDismissed=true") === -1) {
  showModal();
}

// Add event listener to close icon
if (document.querySelector(".announcement-bar__close-icon")) {
  document
    .querySelector(".announcement-bar__close-icon")
    .addEventListener("click", () => {
      hideModal();

      // Set cookie with expiration date
      document.cookie =
        "subscribeDismissed=true; expires=" +
        new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toUTCString() +
        "; path=/";
    });
}
